"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MineJSON = void 0;
const tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("../idls/mine"), exports);
var mine_1 = require("../idls/mine");
Object.defineProperty(exports, "MineJSON", { enumerable: true, get: function () { return mine_1.MineJSON; } });
//# sourceMappingURL=mine.js.map